import React from 'react'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet-async'

import { AvailableRoutes } from '../../configs/RouteConfig'
import { GenerateSteps } from '../../helper/GenerateSteps'
import { getValidUrlForLang } from '../../helper/getValidUrlForLang'
import { useAppContext } from '../../contexts/AppContext'

const AppointmentMissed = () => {
  const { t } = useTranslation()
  const { currentLanguage } = useAppContext()

  const appointmentTypeDescriptions = {
    SMOKEDETECTOR: t('SMOKE DETECTORS'),
    DRINKWATER: t('DRINKING WATER ANALYSIS'),
    MEASUREMENT: t('MEASUREMENT SERVICE'),
  }

  return (
    <>
      <Helmet htmlAttributes={{ lang: currentLanguage }}>
        <title>{t('PSP_SITE_TITLE_APPOINTMENT_MISSED')}</title>
        <link rel='alternate' href={getValidUrlForLang('de')} hrefLang='de' />
        <link rel='alternate' href={getValidUrlForLang('en')} hrefLang='en' />
        <meta name='robots' content='index,follow' />
        <meta
          name='description'
          content={t('PSP_SITE_META_DESCRIPTION_APPOINTMENT_MISSED')}
        />
      </Helmet>

      <GenerateSteps
        steps={AvailableRoutes.appointmentMissed.steps}
        appointmentTypeDescriptions={appointmentTypeDescriptions}
        currentLanguage={currentLanguage}
      />
    </>
  )
}

export default AppointmentMissed
